<nav mat-tab-nav-bar class="easy-tab mb-5" [tabPanel]="tabPanel">
  <a
    mat-tab-link
    *ngFor="let link of navLinks"
    [routerLink]="link.link"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="activeLinkIndex === link.index"
  >
    {{ link.label | async }}
  </a>
</nav>
